import type { Mail, PhoneNumber } from "~domain/global/models/coordinates-model.ts";
import type { Brand } from "~utils/types/brand.ts";

export type SubscriberId = Brand<number, "SubscriberId">;
export type SubscriberCompanyId = Brand<number, "SubscriberCompanyId">;
export type SubscriberMailId = Brand<number, "SubscriberMailId">;
export type SubscriberPhoneId = Brand<number, "SubscriberPhoneId">;

export enum SubscriberMyVoltalisAccess {
  MY_VOLTALIS_2016 = "MY_VOLTALIS_2016",
  MY_VOLTALIS_2022 = "MY_VOLTALIS_2022",
}

export type SubscriberMail = {
  id: SubscriberMailId;
  mail: Mail;
  valid: boolean;
};

export type SubscriberCompany = {
  id: SubscriberCompanyId;
  name: string;
  fullName?: string;
  corporateName?: string;
};

export type SubscriberPhone = {
  id: SubscriberPhoneId;
  phone: PhoneNumber;
  valid: boolean;
};

export type SubscriberFlags = {
  privileged: boolean;
  vip: boolean;
};

export type Subscriber = {
  subscriberId: SubscriberId;
  firstname: string;
  lastname: string;
  mails: Array<SubscriberMail>;
  phones: Array<SubscriberPhone>;
  company?: SubscriberCompany;
  myVoltalisAccess?: SubscriberMyVoltalisAccess;
  flags: SubscriberFlags;
};
